import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FC } from "react";
import { transformInventoryHistoryObject } from "../../utils/helper";


export interface HistoryItem {
  [key: string]: number;
}


interface HoverTableProps {
  historyData: HistoryItem;
  rowData: any

}

const HoverTable: FC<HoverTableProps> = ({ historyData, rowData }) => {


  const sales_history_data = transformInventoryHistoryObject(historyData)


  return (<>
    <div className="dialog-datatable-modal">
      <div className="dialog-datatable-head">
        <p><b>Product ID</b> <span>{rowData.product_id}</span></p>
        <p><b>Product Name</b> <span>{rowData.product_name}</span></p>
        <p><b>Category</b> <span>{rowData.category}</span></p>
      </div>
      <div className="dialog-datatable-wrap">
        <div className="dialog-datatable">
          <div className="table-name">Sales History</div>
          <DataTable value={sales_history_data} scrollable stripedRows>
            <Column field="Date" header="History Range" />
            <Column field="Quantity" header="Quantity" />
          </DataTable>
        </div>
      </div>
    </div>
  </>
  );
};

export default HoverTable;
